import { useCallback, useEffect, useState } from "react";
import { isValidIssueNumber } from "../utils/issueNumber";
export var useIssueNumberInput = function (open, numberEditable, previewLoading, nextIssueNumber, ready) {
    var _a = useState(""), issueNumberInput = _a[0], setIssueNumberInput = _a[1];
    var _b = useState(false), issueNumberDirty = _b[0], setIssueNumberDirty = _b[1];
    useEffect(function () {
        if (!open) {
            setIssueNumberInput("");
            setIssueNumberDirty(false);
        }
    }, [open]);
    useEffect(function () {
        if (open &&
            numberEditable &&
            !issueNumberDirty &&
            !previewLoading &&
            ready) {
            setIssueNumberInput(String(nextIssueNumber));
        }
    }, [
        open,
        numberEditable,
        issueNumberDirty,
        previewLoading,
        nextIssueNumber,
        ready,
    ]);
    var handleIssueNumberChange = useCallback(function (e) {
        setIssueNumberInput(e.target.value);
        setIssueNumberDirty(true);
    }, []);
    var isNumberValid = !numberEditable || isValidIssueNumber(issueNumberInput);
    return { issueNumberInput: issueNumberInput, handleIssueNumberChange: handleIssueNumberChange, isNumberValid: isNumberValid };
};
